module.exports = __webpack_public_path__ + "media/images/icons/tehri-29130a33a9e54ca707aee3d0e0b9914b.svg";